import AdminConfigurations from "./AdminConfigurations";

export default AdminConfigurations;
